import Utils from './core/utils.js';
import Query from './core/query.js';
import Mixins from './core/mixins.js';
import Module from './core/module.js';
import View from './core/view.js';

const SETTINGS = window.settings || {};
const BASE_URL = SETTINGS.base_url || '';

let Tastet = (window.Tastet = {
  version: '1.0',
  settings: SETTINGS,
  base_url: BASE_URL,
  js_url: BASE_URL + '/public/scripts/',
  css_url: BASE_URL + '/public/styles/',
  image_url: BASE_URL + '/public/images/',
  // Classes/Mixins
  Utils: Utils,
  Query: Query,
  Mixins: Mixins,
  Module: Module, // main module to use with everything
  View: View,
  Modules: {}, // all the modules loaded on the site
  Pages: {},
  // helpers
  ready: Utils.dom.ready,
  load: Utils.dom.load,
  page: null,
});

export default Tastet;
